// src/Layout.tsx
import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { initGA, trackPageview } from "../ga4";
import { HelmetWrapper } from "../HelmetWrapper";

const Layout: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    initGA(); // Only runs once
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);

  return <><HelmetWrapper /><Outlet /></>;
};

export default Layout;
